(() => {
  const script = document.currentScript;
  if (!script) return;
  const cleanSrc = script.src.split('?')[0];
  const base = cleanSrc.slice(0, cleanSrc.lastIndexOf('/') + 1);
  window.TFPhotoSwipeAssets = {
    js: `${base}photoswipe-full.js`,
    css: [
      `${base}photoswipe-full.css`,
      `${base}component-photoswipe-full.css`
    ]
  };
})();
